module.exports = __webpack_public_path__ + "img/ian_contact_popup.e5bf9a35.jpg";